"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConfiguration = exports.getConfiguration = void 0;
var configuration = {
    breakpoints: [600, 987, 1281, 1536],
    containerWidths: [640, 1027, 1321, 1576],
    gutterWidths: [16, 20, 20, 20],
    marginWidths: [20, 32, 32, 32],
    gridColumns: 12,
    defaultScreenClass: 'xl',
    maxScreenClass: 'xl',
};
var getConfiguration = function () { return configuration; };
exports.getConfiguration = getConfiguration;
var setConfiguration = function (newConfiguration) {
    configuration = __assign(__assign({}, configuration), newConfiguration);
};
exports.setConfiguration = setConfiguration;
//# sourceMappingURL=config.js.map